module.exports = __webpack_public_path__ + "img/service_content.22ca4a17.png";